import React, { useRef, useState } from "react";
import { useTheme } from '../../context/ThemeContext';
import heic2any from "heic2any";
import HeaderSection from '../../components/HeaderSection/HeaderSection';
import BottomSection from '../../components/BottomSection/BottomSection';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";



export default function HeicToJpgConverter() {
  const [imageSrc, setImageSrc] = useState(null);
     useTheme();
  const [jpgUrl, setJpgUrl] = useState(null);
  const dropRef = useRef(null);

  const handleFile = async (file) => {
    if (file && file.type === "image/heic") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 1,
        });

        const jpgBlob = new Blob([convertedBlob], { type: "image/jpeg" });
        const jpgUrl = URL.createObjectURL(jpgBlob);

        setJpgUrl(jpgUrl);

        const reader = new FileReader();
        reader.onload = (event) => {
          setImageSrc(event.target.result);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        alert("Conversion failed. Make sure the file is a valid HEIC image.");
      }
    } else {
      alert("Please upload a valid HEIC file.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
    dropRef.current.classList.remove("border-blue-500", "bg-blue-50");
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    dropRef.current.classList.add("border-blue-500", "bg-blue-50");
  };

  const handleDragLeave = () => {
    dropRef.current.classList.remove("border-blue-500", "bg-blue-50");
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };

  return (
    <>
    <HeaderSection toolId="heicToJpg" />
    <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4">
      <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
                        <h1 className="text-2xl font-bold mb-2 flex items-center">
                            <FontAwesomeIcon
                                icon={faFileImage}
                                className="mr-3"
                            />
                            HEIC to JPG Converter
                        </h1>
                        <p className="opacity-90">
                            Convert HEIC to JPG with comprehensive
                            validation checks
                        </p>
                    </div>
      <h1 className="text-3xl font-bold mb-6 text-center dark:text-white">HEIC to JPG Converter</h1>

      <div
        ref={dropRef}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        className=" md:max-w-4xl m-6 border-2 border-dashed border-gray-400 p-6 rounded-lg text-center bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 hover:bg-blue-50 cursor-pointer transition mb-4"
      >
        <p className="text-gray-600">Drag & drop HEIC here or</p>
        <label className="cursor-pointer text-blue-600 underline mb-6">
          choose file
          <input
            type="file"
            accept=".heic"
            onChange={handleInputChange}
            className="hidden"
          />
        </label>
      </div>

      {imageSrc && (
        <div className="mb-4 text-center">
          <h2 className="text-lg font-semibold mb-2">Original Preview (HEIC)</h2>
          <img
            src={imageSrc}
            alt="HEIC Preview"
            className="max-w-xs rounded shadow border"
          />
        </div>
      )}

      {jpgUrl && (
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-2">Converted Preview (JPG)</h2>
          <img
            src={jpgUrl}
            alt="JPG Preview"
            className="max-w-xs rounded shadow border mb-4"
          />
          <a
            href={jpgUrl}
            download="converted.jpg"
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Download JPG
          </a>
        </div>
      )}
    </div>
    </div>
    <BottomSection toolId="heicToJpg" />
    </>
  );
}
